module.exports = __webpack_public_path__ + "static/todo-8fa1972ccf87c7163bee04d5cb2c0675.png";